import { motion } from "framer-motion";
import "../../styles/code/DreamJourneySection.css";

const column1 = [
  {
    image: "/images/code/journey/photo1.webp",
    flip: false,
    backText: "",
    heightClass: "tall",
  },
  {
    image: "/images/code/journey/photo6.webp",
    flip: true,
    backText:
      "Chỉ cần internet, bạn có thể tiếp cận tri thức mọi lúc, mọi nơi.",
    heightClass: "short",
    title: "Học từ bất kỳ đâu",
  },
];

const column2 = [
  {
    image: "/images/code/journey/photo4.webp",
    flip: true,
    backText: "Không gian sáng tạo, nơi mỗi ý tưởng đều có cơ hội bứt phá.",
    heightClass: "short",
    title: "Môi trường học truyền cảm hứng",
  },
  {
    image: "/images/code/journey/photo2.webp",
    flip: true,
    backText:
      "Từ lập trình, thiết kế đến kinh doanh – học đúng đam mê, chọn đúng lộ trình.",
    heightClass: "short",
    title: "Chương trình học đa dạng",
  },
  {
    image: "/images/code/journey/photo5.webp",
    flip: true,
    backText: "Áp dụng kiến thức vào dự án thực tế ngay trong quá trình học.",
    heightClass: "short",
    title: "Học đi đôi với hành",
  },
  {
    image: "/images/code/journey/photo3.webp",
    flip: true,
    backText:
      "Người thầy không chỉ giỏi nghề, mà còn truyền lửa đam mê mỗi ngày.",
    heightClass: "short",
    title: "Giảng viên tâm huyết",
  },
  {
    image: "/images/code/journey/photo7.webp",
    flip: false,
    backText: "",
    heightClass: "medium",
  },
];

const column3 = [
  {
    image: "/images/code/journey/photo8.webp",
    flip: false,
    backText: "Bảo trợ tương lai",
    heightClass: "tall",
  },
  {
    image: "/images/code/journey/photo9.webp",
    flip: true,
    backText:
      "Kết nối doanh nghiệp, mở lối sự nghiệp ngay khi còn ngồi trên ghế nhà trường.",
    heightClass: "short",
    title: "Bảo trợ tương lai",
  },
];

// Animation variants
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

function DreamJourneySection() {
  const renderCards = (cards, columnOffset = 0) =>
    cards.map((card, index) => (
      <motion.div
        className={`journey-card ${card.flip ? "journey-card--flip" : ""} ${
          card.heightClass
        }`}
        key={index}
        variants={cardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        custom={index + columnOffset}
      >
        <div className="journey-card__inner">
          <div className="journey-card__front">
            <img
              src={card.image}
              alt={`journey-${index}`}
            />
            {card.flip && card.title && (
              <div className="journey-card__title">{card.title}</div>
            )}
          </div>
          {card.flip && (
            <div className="journey-card__back">
              <p>{card.backText}</p>
            </div>
          )}
        </div>
      </motion.div>
    ));

  return (
    <section className="journey-section">
      <div className="journey-heading">
        <h2 className="journey-heading__text">
          <span className="journey-heading__normal">Bắt đầu hành trình</span>
          <span className="journey-heading__highlight">chinh phục ước mơ</span>
        </h2>
        <p className="journey-heading__description">
          Trường học công nghệ có quy mô hàng đầu khu vực Đông Nam Á, hơn 40 cơ
          sở rải khắp Việt Nam
        </p>
      </div>

      <div className="journey-columns">
        <div className="journey-column">{renderCards(column1, 0)}</div>
        <div className="journey-column column2">
          <div className="column2-top">
            {renderCards(column2.slice(0, 4), 2)}
          </div>
          <div className="column2-bottom">{renderCards([column2[4]], 6)}</div>
        </div>
        <div className="journey-column">{renderCards(column3, 7)}</div>
      </div>
    </section>
  );
}

export default DreamJourneySection;
